import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BasicDetails from "./basicDetails";
import Guardian from "./guardianDetails";
import Sports from "./sportsDetails";
import * as api from "../../common/athleteCommon/API";
import * as funct from "../../common/manipurCommon/FunctionCalls"
import { all_routes } from "../../router/all_routes";
import Swal from "sweetalert2";

const RegisterTabs = () => {

    const [activeTab, setActiveTab] = useState("Personal");
    const [statesList, setStatesList] = useState<any[]>([]);
    const [formData, setFormData] = useState({
        firstName: "", lastName: "", email: "", userName: "", password: "", confpassword: "", phone: "", dateOfBirth: "", permanentAddress: "",
        aadharNo: "", guardianName: "", guardianAddress: "", guardianMobile: "", guardianRelationship: "", guardianAadhar: "", state: "", district: "", city: "", center: "",
        primarySport: "", presentCoach: "", trainingCenterName: "", secondarySport: "", secondarySportPresentCoach: "", secondarySportTrainingCenterName: "", tertiarySport: "", tertiarySportPresentCoach: "", tertiarySportTrainingCenterName: "",
        dominantSide: "", playerPosition: "", currentCompetitionLevel: ""
    });

    const routes = all_routes;
    const navigate = useNavigate();
    const formRef = useRef(null);
    const onboardStep = localStorage.getItem("onboardstep");

    useEffect(() => {
        if (onboardStep === "1") {
            setActiveTab("Guardian"); // Guardian           
            fetchStates();
        } else if (onboardStep === "2") {
            setActiveTab("Sports"); // Sports
        } else {
            setActiveTab("Personal"); // Default: Personal
        }
    }, []);

    async function fetchStates() {
        const stateResponse = await funct.listGeoStates();
        setStatesList(Array.isArray(stateResponse) ? stateResponse : [])
    }

    // Keep all fields controlled
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (!formRef.current) return;
        // Validate current form
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
            return;
        }
        if (activeTab === "Personal") {
            saveBasicInfo();
        }
        else if (activeTab === "Guardian") {
            saveGuardianInfo();
        }
    };

    const handleBack = (e) => {
        if (activeTab === "Sports") setActiveTab("Guardian");
        else if (activeTab === "Guardian") setActiveTab("Personal");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
            return;
        }
        const athleteId = localStorage.getItem("athleteId");
        const frmDta = new FormData();
        frmDta.append("primarySport", formData.primarySport);
        frmDta.append("presentCoach", formData.presentCoach);
        frmDta.append("trainingCenterName", formData.trainingCenterName);
        frmDta.append("secondarySport", formData.secondarySport);
        frmDta.append("secondarySportPresentCoach", formData.secondarySportPresentCoach);
        frmDta.append("secondarySportTrainingCenterName", formData.secondarySportTrainingCenterName);
        frmDta.append("tertiarySport", formData.tertiarySport);
        frmDta.append("tertiarySportPresentCoach", formData.tertiarySportPresentCoach);
        frmDta.append("tertiarySportTrainingCenterName", formData.tertiarySportTrainingCenterName);
        frmDta.append("dominantSide", formData.dominantSide);
        frmDta.append("playerPosition", formData.playerPosition);
        frmDta.append("currentCompetitionLevel", formData.currentCompetitionLevel);

        const regAthlt = api.AthleteSportInfo + "/" + athleteId;
        fetch(regAthlt, {
            method: "POST",
            body: frmDta
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            navigate(routes.manipurlogin);
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    };

    function saveBasicInfo() {
        const frmDta = new FormData();
        frmDta.append("firstName", formData.firstName);
        frmDta.append("lastName", formData.lastName);
        frmDta.append("email", formData.email);
        frmDta.append("userName", formData.userName);
        frmDta.append("password", formData.password);
        frmDta.append("confpassword", formData.confpassword);
        frmDta.append("phone", formData.phone);
        frmDta.append("dateOfBirth", formData.dateOfBirth);
        frmDta.append("permanentAddress", formData.permanentAddress);

        const regAthlt = api.Athlete;
        fetch(regAthlt, {
            method: "POST",
            body: frmDta
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    localStorage.setItem("athleteId", result.data);
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            setActiveTab("Guardian");
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function saveGuardianInfo() {
        const athleteId = localStorage.getItem("athleteId");
        const frmDta = new FormData();
        // frmDta.append("dateOfBirth", formData.dateOfBirth);
        // frmDta.append("permanentAddress", formData.permanentAddress);
        frmDta.append("aadharNo", formData.aadharNo);
        frmDta.append("guardianName", formData.guardianName);
        frmDta.append("guardianAddress", formData.guardianAddress);
        frmDta.append("guardianMobile", formData.guardianMobile);
        frmDta.append("guardianRelationship", formData.guardianRelationship);
        frmDta.append("guardianAadhar", formData.guardianAadhar);
        frmDta.append("state", formData.state);
        frmDta.append("district", formData.district);
        frmDta.append("city", formData.city);
        frmDta.append("center", formData.center);

        const regAthlt = api.AthleteGaurdianInfo + "/" + athleteId;
        fetch(regAthlt, {
            method: "POST",
            body: frmDta
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            setActiveTab("Sports");
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    const tabData = [
        {
            icon: <i className="fas fa-user" />,
            name: "Personal",
            content: <BasicDetails formData={formData} onChange={handleChange} />
        },
        {
            icon: <i className="fas fa-id-card" />,
            name: "Guardian",
            content: <Guardian formData={formData} onChange={handleChange} statesList={statesList} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Sports",
            content: <Sports formData={formData} onChange={handleChange} />
        },
    ]

    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Register</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                    // onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <form ref={formRef}>
                                    <div className="tab-content">
                                        {tabData
                                            .filter(tab => tab.name === activeTab)
                                            .map((tab, i) => (
                                                <div key={i}>{tab.content}</div>
                                            ))}
                                    </div>
                                    <div className="tab-footer" style={{ marginTop: "10px" }}>
                                        <div className="d-flex justify-content-end align-items-center">
                                            {/* <div>
                                                {activeTab !== "Personal" && (
                                                    <button
                                                        type="button"
                                                        onClick={handleBack}
                                                        className="btn btn-secondary"
                                                    >
                                                        <i className="fas fa-arrow-left" />&nbsp; Back
                                                    </button>
                                                )}
                                            </div> */}
                                            <div>
                                                {activeTab !== "Sports" ? (
                                                    <button
                                                        // onClick={() =>
                                                        //     setActiveTab(activeTab === "Personal" ? "Guardian" : "Sports")
                                                        // }
                                                        type="button"
                                                        onClick={handleNext}
                                                        className="btn btn-secondary"
                                                    >
                                                        Next &nbsp;<i className="fas fa-arrow-right" />
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={handleSubmit}
                                                        className="btn btn-secondary"
                                                    >
                                                        Submit
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisterTabs;